import React from 'react';
import { Link } from 'react-router-dom';
import { openKnotsCopy } from '../utils/constants/openKnotsLabel';

/**
 * Friendly 403-style page when the user is signed in but not allowed to access a feature (e.g. Open Knots disabled for buyer org).
 */
const NotAuthorizedPage = ({
    title = '403 — Not authorized',
    message,
    homeTo = '/dashboard',
    showBackLink = true,
}) => {
    return (
        <div className='col-12 px-4 py-5'>
            <h2 className='mt-2 font-semiBold'>{title}</h2>
            <p className='text-neutral-800 font-b2 mt-3'>{openKnotsCopy(message)}</p>
            {showBackLink && homeTo && (
                <p className='mt-4'>
                    <Link to={homeTo}>
                        <span className='text-secondary-900'>Back to dashboard</span>
                    </Link>
                </p>
            )}
        </div>
    );
};

export default NotAuthorizedPage;
